
export const triggerTrace = function () {
    const traceFunctions = ['wFbPixelTrace', 'wOpenAiAdsTrace'];
    traceFunctions.forEach(function(func) {
        try {
            if (typeof window[func] === 'function') {
                window[func]();
            }
        } catch (e) {
            // console.error(e);
        }

    });
}

export const addScript = function (id, scriptText) {
    let script  = document.createElement("script");
    script.id = id;
    script.innerHTML = `try{${scriptText}}catch (e) {}`;
    document.body.appendChild(script);
}

